import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-download-2-line text-xl text-primary-400"></i>
                </span>
                <span className="font-semibold text-lg">jm下载指南</span>
              </div>
              <p className="text-sm text-background-50/60 leading-relaxed">
                专注提供jm下载最新版方法、安装教程和常见问题解答，助您安全、快速地完成jm下载。
              </p>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4 text-background-50/90">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4 text-background-50/90">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/xiazai-zhinan" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    下载指南
                  </Link>
                </li>
                <li>
                  <Link to="/category/changjian-wenti" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    常见问题
                  </Link>
                </li>
                <li>
                  <Link to="/category/anquan-fanghu" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    安全防护
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4 text-background-50/90">热门关键词</h4>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm下载</span>
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm下载最新版</span>
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm下载地址</span>
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm安全下载</span>
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm安装教程</span>
                <span className="px-3 py-1 bg-background-50/10 rounded-full text-xs text-background-50/60">jm下载失败</span>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {currentYear} jm下载指南. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
                使用条款
              </a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}